<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/studio')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="name">Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="name" v-model="addData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="addData.branch_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="ip_address_machine">IP Address Machine</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="ip_address_machine" v-model="addData.ip_address_machine" name="ip_address_machine" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('ip_address_machine') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="addData.status" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addStudio',
  data: function () {
    return {
      dataBranch: [],
      addData: {
        name: '',
        ip_address_machine: '',
        branch_id: null,
        status: null,
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.post('fitness/v1/studio/', this.addData).then(response => {
            this.$router.push('/studio')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
